import NoRouteFoundPage from 'pages/404/NoRouteFoundPage';
import enhance from 'pages/404/NotRoutFound.enhancer';

export default enhance(NoRouteFoundPage);
